// import { WNATIVE } from '@emberswap/emberswap-sdk2/dist/constants'
import { /* Native,*/ Token } from '@emberswap/emberswap-sdk2/dist/entities'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'

// import { Address, Type } from '@emberswap/emberswap-sdk2/dist/types'
// import { useMemo } from 'react'
// import { useToken } from 'wagmi'
// 
// import { isAddress } from '../../functions'
import { useCombinedActiveList } from '../../state/lists/hooks'
import { useTokensFromMap } from './useTokensFromMap'

/**
 * @param {ChainId | undefined} chainId
 * @return {Token}
 */
export function useTokens(chainId: ChainId | undefined): { [address: string]: Token } {
  return useTokensFromMap(chainId, useCombinedActiveList())
}
// import { useUserAddedTokens } from '../state/user/hooks'
/** Check if currency is included in custom list from user storage
 * @param {Currency | undefined | null}currency
 * @return {boolean}
 */
// export function useIsUserAddedToken(currency: Currency | undefined | null): boolean {
//   const userAddedTokens = useUserAddedTokens()
//   if (!currency) {
//     return false
//   }
//   return !!userAddedTokens.find((token: any) => currency.equals(token))
// }
/**
 * @param {string | undefined}currencyId
 * @return {Type | null | undefined}
 */
// export function useCurrency(currencyId: string | undefined, chainId: ChainId): Type | null | undefined {
//   const native = useMemo(() => Native.onChain(chainId), [chainId])
//   const isNative = currencyId?.toUpperCase() === native.symbol.toUpperCase()
//   const { data: _token } = useToken({
//     address: isAddress(currencyId) ? (currencyId as Address) : undefined,
//     chainId,
//   })
// 
//     const token = useMemo(() => {
//       if (!_token) return undefined
//       const { decimals, address, symbol, name } = _token
//       return new Token({ chainId, decimals, address, symbol, name })
//     }, [_token, chainId])
// 
//   return isNative ? native : token
// }
